import axios from 'axios';
import { IPriorityUpsert } from '../../../@types/model/masterData/priority/priorityUpsert';
import { IPriority } from '../../../@types/model/masterData/priority/priority';
import { UpsertTypeEnum } from '../../../@types/enum/upsertType';
import { IPriorityReorderUpsert } from '../../../@types/model/masterData/priority/priorityReorderUpsert';

export default class PriorityHttpService {
    public static getList = async (lastSyncedTimeUnix : number, signal ?: AbortSignal) : Promise<Array<IPriority>> => {
        const result = await axios.get(`${API_URL}/v1/MasterData/Priority/GetList`, {
            params: {
                lastSyncedTimeUnix
            },
            signal
        });

        return result.data;
    }

    public static reorder = async (upserts : Array<IPriorityReorderUpsert>) : Promise<Array<IPriority>> => {
        const result = await axios.post(`${API_URL}/v1/MasterData/Priority/Reorder`, upserts);

        return result.data;
    }

    public static upsert = async (upsert : IPriorityUpsert, type : UpsertTypeEnum) : Promise<IPriority> => {
        const result = await axios.post(`${API_URL}/v1/MasterData/Priority/${type}`, upsert);

        return result.data;
    }

    public static delete = async (id : number) : Promise<void> => {
        return await axios.delete(`${API_URL}/v1/MasterData/Priority/Delete`, {
            params: { id },
        });
    }
}